export default "__VITE_ASSET__f9ec77c4__"